export default {
  release: '16.0',
  date: 'May 2023',
  releasePostUrl: 'https://docs.gitlab.com/releases/16/gitlab-16-0-released/#this-months-notable-contributor-jimmy-berry',
  contributors: [
    {
      name: 'Jimmy Berry',
      gitlabUsername: 'jimmy-outschool',
    },
  ],
  writeUp: `Jimmy [improved the merge request security widget](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/117594) by correcting which merge base is used for comparing branches on completed pipelines in the merge request.
Previously, the merge request security widget was comparing the most recent security scan of a completed pipeline on the main branch of the repository.  For the vulnerability findings in the merge request security widget to be accurate, we needed to adjust the logic and compare the feature branch to the main branch at the time the feature was branched from main. Without this change users might see misleading results. This was already an [issue](https://gitlab.com/groups/gitlab-org/-/epics/10092) on our roadmap, and Jimmy contributed and accelerated this improvement not only for them, but for all GitLab users. 

Jimmy [stated](https://gitlab.com/gitlab-com/www-gitlab-com/-/issues/34100#note_1395183419):

> I've contributed to a variety of open source projects, but have never experienced such a helpful review process.

Thank you Jimmy for helping us iterate on the logic for vulnerability findings and improve the security features in GitLab!`,
};
